







































































































































































































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "../node_modules/vue";
import Component from "../node_modules/vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { DateHelper } from "../core/helpers/dateHelper";
import { Format } from "../core/helpers/formatHelper";
import Popup from "../components/popup/popup.vue";
import { ShopService } from "../core/services/shopService";
import { Global } from "../core/helpers/global";
import CtaButton from "../components/ctaButton/ctaButton.vue";
import CategorySelector from "../components/filters/CategorySelector.vue";
import SessionCard from "../components/bookings/SessionCard.vue";
import MobileHeader from "../components/bookings/MobileHeader.vue";
import DateStripPicker from "../components/date/DateStripPicker.vue";
import Centers from "../components/center/center.vue";
import store from "../core/store";

@Component({
  components: {
    Popup,
    CtaButton,
    CategorySelector,
    SessionCard,
    MobileHeader,
    DateStripPicker,
    Centers,
  },
})
export default class BookingsByPlacePage extends Vue {
  anyByType: boolean = false;
  bookAllowed: boolean = false;
  errorMsg: string = "";
  date: string | undefined = "";
  bookingTypeId: number | null = null;
  data: any[] = [];
  bookingTypes: any[] = [];
  bookingTypesByPlace: any[] = [];
  showPopUpConfirm: boolean = false;
  bookingSelected: any = {};
  loaded: boolean = false;
  showWaitlist: boolean = false;
  waitlistMsg: string = "";

  selectedPlace: string | null = null;
  centerId: number | null = null;
  selectedResources: Record<string, string | null> = {};
  sortKey: string = "time";
  pageEl: HTMLElement | null = null;

  created() {
    if (this.$route.query.date !== undefined) {
      const query: any =
        this.$route && (this.$route as any).query
          ? (this.$route as any).query
          : {};
      this.date = query.date ? query.date.toString() : "";
    }

    if (this.date === null || this.date === "" || this.data === undefined) {
      this.date = DateHelper.toSystemString(store.getters.localNow);
    }

    if (this.$route.query.place !== undefined) {
      this.selectedPlace = String(this.$route.query.place);
    }
  }

  async mounted() {
    this.pageEl = document.querySelector(".page");
    if (this.pageEl) {
      this.pageEl.classList.add("page--classes");
    }

    let url = `${Settings.HostName}/api/publicbookings/filters`;
    let res = await new CrudService().httpGet(url);
    if (res == null || res.ok === false) {
      console.error("Crash getting filters");
      this.errorMsg = this.$t("Crash").toString();
      return;
    }

    this.bookingTypes = res.model.bookingTypes;
    if (
      this.bookingTypes === null ||
      this.bookingTypes === undefined ||
      this.bookingTypes.length === 0
    ) {
      this.errorMsg = this.$t("No bookings by place available").toString();
      return;
    }

    this.bookingTypesByPlace = this.bookingTypes.filter(
      (y) => y.byPlace === true,
    );
    if (this.bookingTypes.length === 1) {
      this.bookingTypeId = this.bookingTypes[0].id;
      this.bookingTypes = [];
    }

    if (this.$route.params.bookingTypeId !== undefined) {
      this.bookingTypeId = Number(this.$route.params.bookingTypeId);
    }

    await this.loadData();
    this.loaded = true;

    if (this.$route.query.bookingId !== undefined) {
      this.bookingSelected = this.data.find(
        (y) => y.id == Number(this.$route.query.bookingId),
      );

      if (this.bookingSelected === undefined) {
        console.error(
          "wrong url booking id param" + this.$route.query.bookingId,
        );
        this.errorMsg = this.$t(
          "Ups something went wrong Please try again",
        ).toString();
        return;
      }
      this.showPopUpConfirm = true;
    }
  }

  beforeDestroy() {
    if (this.pageEl) {
      this.pageEl.classList.remove("page--classes");
    }
  }

  get userLocale() {
    const stored = localStorage.getItem(window.location.host + "_culture");
    return stored || "es-ES";
  }

  get minSelectableDate() {
    return store.getters.localNow;
  }

  get showFilters() {
    return this.$route.params.bookingTypeId === undefined;
  }

  get availablePlaces() {
    const places = new Set<string>();
    for (const booking of this.data) {
      const place = this.getBookingPlace(booking);
      if (place) {
        places.add(place);
      }
    }
    return Array.from(places);
  }

  get resourceFilters() {
    const groups = new Map<string, Map<string, any>>();
    for (const booking of this.data) {
      for (const resource of booking.resourceGroups || []) {
        if (!groups.has(resource.group)) {
          groups.set(resource.group, new Map());
        }
        groups.get(resource.group)!.set(resource.name, { id: resource.name, name: resource.name });
      }
    }
    return Array.from(groups.entries())
      .map(([group, items]) => ({ group, items: Array.from(items.values()) }))
      .filter((filter) => filter.items.length > 1);
  }

  get title() {
    const bookingType =
      this.bookingTypesByPlace.find((bt) => bt.id === this.bookingTypeId) ||
      this.bookingTypesByPlace[0];
    return bookingType ? bookingType.name || bookingType.description : this.$t("Sessions").toString();
  }

  get fromPrice() {
    const prices = this.filteredBookings
      .map((booking) => this.getBookingNumericPrice(booking))
      .filter((value) => value > 0);
    return prices.length ? Format.formatCurrency(String(Math.min(...prices))) : "";
  }

  get filteredBookings() {
    let items = [...this.data];
    if (this.selectedPlace) {
      items = items.filter(
        (booking) => this.getBookingPlace(booking) === this.selectedPlace,
      );
    }
    for (const group of Object.keys(this.selectedResources)) {
      const name = this.selectedResources[group];
      if (!name) {
        continue;
      }
      items = items.filter((booking) =>
        (booking.resourceGroups || []).some(
          (r: any) => r.group === group && r.name === name,
        ),
      );
    }
    return this.sortBookings(items);
  }

  formatMonth(date: Date) {
    const value = date.toLocaleDateString(this.userLocale, { month: "short" });
    return this.cleanShortLabel(value);
  }

  formatDay(date: Date) {
    return date
      .getDate()
      .toString()
      .padStart(2, "0");
  }

  cleanShortLabel(value: string) {
    if (!value) return "";
    const cleaned = value.replace(".", "");
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  }

  handleCenterSelected(center: any) {
    if (this.centerId !== null && this.centerId !== center.id) {
      this.$router.push("/bookingtypes");
      return;
    }
    this.centerId = center.id;
  }

  selectPlace(place: string | null) {
    this.selectedPlace = place;
  }

  sortBookings(items: any[]) {
    const sorted = [...items];
    sorted.sort((a, b) => {
      switch (this.sortKey) {
        case "time":
          return this.getBookingTime(a) - this.getBookingTime(b);
        case "duration":
          return this.getBookingDuration(a) - this.getBookingDuration(b);
        case "availability":
          return (
            this.getBookingAvailabilityScore(b) -
            this.getBookingAvailabilityScore(a)
          );
        case "price":
        default:
          return (
            this.getBookingNumericPrice(a) - this.getBookingNumericPrice(b)
          );
      }
    });
    return sorted;
  }

  getBookingTime(booking: any) {
    if (booking.start) {
      const date = DateHelper.toSystemDate(booking.start);
      if (date) {
        return date.getTime();
      }
    }
    if (booking.startHour) {
      const parts = booking.startHour.split(":");
      if (parts.length >= 2) {
        const hour = parseInt(parts[0], 10);
        const min = parseInt(parts[1], 10);
        if (!Number.isNaN(hour) && !Number.isNaN(min)) {
          return hour * 60 + min;
        }
      }
    }
    return 0;
  }

  getBookingDuration(booking: any) {
    if (typeof booking.duration === "number") return booking.duration;
    if (typeof booking.duration === "string") {
      const parsed = parseInt(booking.duration, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  }

  getBookingAvailabilityScore(booking: any) {
    if (
      booking.maxParticipants !== undefined &&
      booking.maxParticipants !== null &&
      booking.participantsIn !== undefined &&
      booking.participantsIn !== null
    ) {
      const max = Number(booking.maxParticipants);
      const current = Number(booking.participantsIn);
      if (!Number.isNaN(max) && !Number.isNaN(current)) {
        return max - current;
      }
    }
    return 0;
  }

  getBookingNumericPrice(booking: any) {
    const value = store.state.settings.PriceWithTaxes
      ? booking.price
      : booking.netPrice;
    const parsed = Number.parseFloat(String(value || 0));
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  getBookingCardPrice(booking: any) {
    if (!booking) return "";
    return this.getPrice(booking.price, booking.netPrice);
  }

  getSessionTime(booking: any) {
    if (!booking) return "";
    if (booking.startHour) return booking.startHour;
    if (booking.start) {
      const date = DateHelper.toSystemDate(booking.start);
      if (date) {
        return DateHelper.toCultureTimeString(date);
      }
    }
    return "";
  }

  getAssetImage(image: string) {
    if (!image) {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    if (image.startsWith("http")) {
      return image;
    }
    return store.state.settings.Uploads + "/" + image;
  }

  getInstructorName(booking: any) {
    if (booking.instructorName) return booking.instructorName;
    if (booking.resourceName) return booking.resourceName;
    if (Array.isArray(booking.resources) && booking.resources.length > 0) {
      return booking.resources[0];
    }
    return booking.bookingTypeName || "";
  }

  getInstructorImage(booking: any) {
    const image =
      booking.instructorImage ||
      booking.resourceImage ||
      booking.instructorAvatar ||
      booking.image;
    if (!image) return "";
    return this.getAssetImage(image);
  }

  getBookingPlace(booking: any) {
    return (
      booking.place ||
      booking.placeName ||
      booking.center ||
      booking.centerName ||
      booking.location ||
      ""
    );
  }

  formatSessionDate(booking: any) {
    if (booking.start) {
      const date = DateHelper.toSystemDate(booking.start);
      if (date) {
        const day = this.formatDay(date);
        const month = this.formatMonth(date);
        return `${day} ${month}`;
      }
    }
    return booking.date || "";
  }

  formatSessionDuration(booking: any) {
    if (booking.duration === null || booking.duration === undefined) return "";
    const minLabel = this.$t("min").toString() || "min";
    if (typeof booking.duration === "string") {
      const raw = booking.duration.trim();
      const parsed = parseInt(raw, 10);
      if (Number.isNaN(parsed)) {
        return raw;
      }
      const lower = raw.toLowerCase();
      if (
        lower.indexOf("min") !== -1 ||
        lower.indexOf("minuto") !== -1 ||
        lower.indexOf("minute") !== -1
      ) {
        return `${parsed} ${minLabel}`;
      }
      if (raw.match(/[a-zA-Z]/)) {
        return raw;
      }
      return `${parsed} ${minLabel}`;
    }
    if (typeof booking.duration === "number") {
      return `${booking.duration} ${minLabel}`;
    }
    return "";
  }

  formatSessionCapacity(booking: any) {
    if (
      booking.maxParticipants === undefined ||
      booking.maxParticipants === null ||
      booking.participantsIn === undefined ||
      booking.participantsIn === null
    ) {
      return "";
    }
    return `${booking.participantsIn}/${booking.maxParticipants}`;
  }

  getAvailability(booking: any) {
    if (
      booking.maxParticipants === undefined ||
      booking.maxParticipants === null ||
      booking.participantsIn === undefined ||
      booking.participantsIn === null
    ) {
      return null;
    }
    const max = Number(booking.maxParticipants);
    const current = Number(booking.participantsIn);
    if (Number.isNaN(max) || Number.isNaN(current)) {
      return null;
    }
    const remaining = max - current;
    if (remaining <= 2) {
      return { label: this.$t("Few spots left").toString(), type: "low" };
    }
    return { label: this.$t("Available").toString(), type: "ok" };
  }

  async loadData() {
    this.errorMsg = "";
    this.showWaitlist = false;
    this.waitlistMsg = "";
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }

    this.data = [];

    const url = `${Settings.HostName}/api/publicbookings/byplace-list`;

    Global.TriggerDomId = "loader";
    const res = await new CrudService().httpPost(url, {
      date: this.date,
      bookingTypeId: this.bookingTypeId,
      customerId: cid === 0 ? null : cid,
    });

    if (res == null || res == undefined) {
      console.error("Crash getting bookings by place");
      return;
    }

    if (res.ok === false) {
      this.errorMsg = res.errorMsg;
      return;
    }

    if (res.data === null || res.data === undefined || res.data.length === 0) {
      this.errorMsg =
        this.$t("Oops! there is nothing you can join").toString() +
        ". " +
        this.$t("Try changing the date").toString();
      // The center is open that day (a closed one fails with ok = false): the sessions
      // are full or there are none left to join, so the customer can queue for it.
      this.showWaitlist = true;
      return;
    }

    this.data = res.data;

    if (
      this.selectedPlace &&
      !this.availablePlaces.includes(this.selectedPlace)
    ) {
      this.selectedPlace = null;
    }
    for (const group of Object.keys(this.selectedResources)) {
      const filter = this.resourceFilters.find((f) => f.group === group);
      if (!filter || !filter.items.some((item) => item.id === this.selectedResources[group])) {
        this.selectedResources[group] = null;
      }
    }
  }

  book(e: any, id: number) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.errorMsg = "";
    const booking = this.data.find((y) => y.id === id);
    if (booking === undefined) {
      console.error("not booking found " + id);
    }

    const url =
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
        ? "/booking-visual/" +
          id +
          "/" +
          booking.bookingTemplateId +
          "?date=" +
          this.date
        : "/bookings-byplace?bookingId=" + id + "&date=" + this.date;

    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin", { backUrl: url });
      return;
    }

    if (
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
    ) {
      return this.$router.push(url);
    }

    this.bookingSelected = booking;
    this.showPopUpConfirm = true;
  }

  async addToCart(e: any) {
    this.errorMsg = "";
    e.preventDefault();
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }
    if (cid === 0 || cid === null) {
      this.errorMsg = this.$t("Please login or register").toString();
      return;
    }

    const bookingId = this.bookingSelected.id;
    if (bookingId === null || bookingId === undefined) {
      this.errorMsg = this.$t(
        "Ups something went wrong Please try again",
      ).toString();
      return;
    }

    let url = `${
      Settings.HostName
    }/api/publicbookings/byplace-prebook-place/${cid}/${bookingId}`;
    if (this.$route.query.placeId !== undefined) {
      url += "/" + this.$route.query.placeId;
    }
    const res = await new CrudService().httpPost(url);

    if (res == null || res == undefined) {
      console.error("Crash getting bookings by place");
      this.errorMsg = this.$t("Crash").toString();
      return;
    }
    if (res.ok === false) {
      this.errorMsg = res.errorMsg;
      return;
    }

    if (res.model.serviceFree === true) {
      return this.$router.push("/customer-bookings");
    }

    let sale = res.model;
    sale.title = sale.description;
    sale.cancelUrl = `publicbookings/cancel/${bookingId}/${cid}`;

    new ShopService().addSaleToCart(sale, e.currentTarget);
    this.$router.push("/checkout");
  }

  getPrice(price: string, netPrice: string) {
    return store.state.settings.PriceWithTaxes
      ? Format.formatCurrency(price)
      : Format.formatCurrency(netPrice);
  }

  filterByBookingType(id: number | null, e?: any) {
    if (e !== null && e !== undefined) {
      e.preventDefault();
    }
    this.bookingTypeId = id;
    this.loadData();
  }

  async joinWaitlist(e: any) {
    e.preventDefault();
    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin");
      return;
    }
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicwaitlist/add`,
      {
        bookingTypeId: this.bookingTypeId,
        date: Format.IsNull(this.date) ? store.getters.localNow : this.date,
      },
    );
    if (res == null || res.ok !== true) {
      this.waitlistMsg = this.$t("Crash").toString();
      return;
    }
    this.waitlistMsg =
      res.added === true
        ? this.$t("You are on the waiting list").toString()
        : this.$t("You were already on the waiting list").toString();
  }

  filterByDate(date: any) {
    this.date = date.systemStrDate;
    this.loadData();
  }

  goBack() {
    if (window.history.length > 1) {
      this.$router.back();
      return;
    }
    this.$router.push("/");
  }
}
